export function formatAcn(acn: string | undefined | null) {
    if(acn == null || acn.length !== 9) {
        return acn;
    }

    const [a, b, c, d, e, f, g, h, i] = acn.split('');

    return `${a}${b}${c} ${d}${e}${f} ${g}${h}${i}`;
}